import { useSelector } from 'react-redux';

import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as scenarioGridSelectors from '@makemydeal/dr-dash-store/selectors/scenarioGridSelectors';
import { LEASE } from '@makemydeal/dr-platform-types';

import { FinanceTermRow } from './FinanceTermRow';
import { FlexBuyTermRow } from './FlexBuyTermRow';
import { LeaseTermRow } from './LeaseTermRow';

export const TermRow = () => {
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isFlexBuyDeal = useSelector(scenarioGridSelectors.isFlexBuyDeal);

    if (isFlexBuyDeal) return <FlexBuyTermRow />;
    return offerType === LEASE ? <LeaseTermRow /> : <FinanceTermRow />;
};
